import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';

export class BavBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: () => BenefitAttribute[] = () => [
    {
      id: 'bavAdditionalPaymentPercent',
      accessorFn: value => value.bavOptions?.additionalPaymentPercent,
      header: 'BAV.fields.additionalPaymentPercent',
      renderer: value => (typeof value === 'number' ? `${value || 0}%` : null),
    },
    {
      id: 'bavVWLConversion',
      accessorFn: value => value.bavOptions?.vwlConversion,
      header: 'BAV.fields.vwlConversion',
      renderer: value => (typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null),
    },
    {
      id: 'bavNotInterested',
      accessorFn: employee =>
        employee && 'bavNotInterested' in employee && employee?.bavNotInterested ? <Trans i18nKey="employeeTabs.confirmed" /> : '',
      header: 'employeeTabs.header.notInterested',
    },
  ];
}
